/**
 * Mock Card Data Utility
 *
 * Generates sample BoardTask data for Kanban column previews in Create Board form.
 * These mock cards allow the preview to use the actual KanbanCard component
 * instead of hardcoded divs, achieving true WYSIWYG.
 */

import { BoardTask } from '@/types/models/BoardTask';
import { BoardTaskPriority } from '@/types/enums/BoardTaskPriority';

/**
 * Creates mock cards for preview purposes
 * @param count Number of cards to generate (default: 3)
 * @param columnName Column name for unique IDs
 * @returns Array of mock BoardTask objects
 */
export const createMockTasks = (
  count: number = 3,
  columnName: string
): BoardTask[] => {
  const cards: BoardTask[] = [];

  // Card templates with variety
  // IMPORTANT: Pre-sorted by priority (high → medium → low) to match real Kanban sorting
  const templates = [
    {
      title: 'High BoardTaskPriority Task',
      description: 'Task with high priority',
      priority: BoardTaskPriority.HIGH,
      estimated_pomodoros: 3,
      created_at: new Date('2024-01-01T10:00:00Z'),
    },
    {
      title: 'Sample Card',
      description: 'Example task description',
      priority: BoardTaskPriority.MEDIUM,
      estimated_pomodoros: 2,
      created_at: new Date('2024-01-01T11:00:00Z'),
    },
    {
      title: 'Low BoardTaskPriority Item',
      description: undefined,
      priority: BoardTaskPriority.LOW,
      estimated_pomodoros: 1,
      created_at: new Date('2024-01-01T12:00:00Z'),
    },
  ];

  for (let i = 0; i < count && i < templates.length; i++) {
    const template = templates[i];
    cards.push({
      id: `mock-${i}-${columnName.toLowerCase().replace(/\s+/g, '-')}`,
      board_id: 'mock-board',
      organization_id: 'mock-org',
      status_id: 'mock-status',
      created_by: 'mock-user',
      title: template.title,
      description: template.description,
      priority: template.priority,
      estimated_pomodoros: template.estimated_pomodoros,
      created_at: template.created_at.toISOString(),
    });
  }

  return cards;
};
